var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 7.5H17.25V6L19.5 6V7.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 7.5L4.5 7.5V6L12.75 6V7.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.5C3 3.67157 3.67157 3 4.5 3H19.5C20.3284 3 21 3.67157 21 4.5V6.78467C21 7.21722 20.8133 7.62871 20.4878 7.91354L15 12.7153V19.4115C15 19.9796 14.679 20.499 14.1708 20.7531L11.2577 22.2097C10.2204 22.7283 9 21.9741 9 20.8144V12.7153L3.51224 7.91354C3.18672 7.62871 3 7.21722 3 6.78467V4.5ZM19.5 4.5H4.5V6.78467L9.98776 11.5865C10.3133 11.8713 10.5 12.2828 10.5 12.7153V20.8144C10.5 20.8306 10.5036 20.8387 10.5065 20.8438C10.5105 20.8506 10.5176 20.8588 10.5285 20.8654C10.5393 20.8721 10.5497 20.8749 10.5576 20.8754C10.5635 20.8757 10.5724 20.8753 10.5868 20.8681L13.5 19.4115V12.7153C13.5 12.2828 13.6867 11.8713 14.0122 11.5865L19.5 6.78467V4.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 6.75C15.75 7.16421 15.4142 7.5 15 7.5C14.5858 7.5 14.25 7.16421 14.25 6.75C14.25 6.33579 14.5858 6 15 6C15.4142 6 15.75 6.33579 15.75 6.75Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.a71159ee.svg";
export { ForwardRef as ReactComponent };